import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import { Message } from 'semantic-ui-react';

export type Props = {
    title: string;
    content?: string | React.ReactElement;
    visible?: boolean;
    style?: React.CSSProperties;
};

export default class WarningMessage extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { title, content, visible, style } = this.props;

        return (
            <Message
                style={style}
                warning
                visible={visible}
                className="warning-message"
            >
                <Message.Header>
                    <div className="icon" aria-hidden>
                        <ErrorIcon
                            htmlColor="rgb(246, 139, 31)"
                            style={{
                                fontSize: 25
                            }}
                        />
                    </div>
                    {title}
                </Message.Header>
                {content && <Message.Content>{content}</Message.Content>}
            </Message>
        );
    }
}
